import "./single.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { ContentCopyOutlined } from "@mui/icons-material";
import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import { useUserData } from "../../context/UserContext";

const Single = ({ type, bookID }) => {
  let dataValue;
  switch (type) {
    case "main":
      dataValue = {
        collectionVal: "eLibrary",
        emptyMessage:
          "No books found yet. Start adding some to build your library.",
        redirectVal: "library",
        editMessage: "Edit",
      };
      break;
    case "pending":
      dataValue = {
        collectionVal: "pendingBooks",
        emptyMessage:
          "No books found yet to approve. Start adding some to build your library.",
        redirectVal: "pending-books",
        editMessage: "Edit & Approve",
      };
      break;
    default:
      break;
  }

  const productId = bookID;
  const [openToast, setOpenToast] = useState(false);
  const [bookData, setBookData] = useState({});
  const [publishedOn, setPublishedOn] = useState();
  const navigate = useNavigate();
  const [openLoading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [controlAccess, setControlAccess] = useState("limited");
  const [errorMessage, setErrorMessage] = useState(
    "Something went wrong.\nPlease try again"
  );
  const { userData } = useUserData();

  const handleEditClick = () => {
    const editUrl = `/library/${productId}/edit`;
    navigate(editUrl, { state: { bookData, type } });
  };

  useEffect(async () => {
    try {
      const bookref = doc(db, dataValue.collectionVal, productId);
      const docSnap = await getDoc(bookref);
      setInitialLoading(false);

      if (docSnap.exists()) {
        setDataAvailable(true);
        const publishDate = docSnap.data().publish_on
          ? docSnap.data().publish_on.toDate()
          : null;

        const ebookData = docSnap.data();
        const bookDataWithId = { ...ebookData, id: docSnap.id };
        setBookData(bookDataWithId);
        setPublishedOn(publishDate);
        document.title = "" + ebookData.name;
      } else {
        setErrorMessage(
          "There is no such details available. Please try again."
        );
      }
    } catch (error) {
      setInitialLoading(false);
      setErrorMessage("Error - " + error);
    }
  }, []);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "Not available";

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    return timestamp.toLocaleDateString("en-US", options);
  };

  const handleCopiedTextClick = () => {
    navigator.clipboard.writeText(bookData.pdf_password);
    setOpenToast(true);
  };

  const handleToastClose = () => {
    setOpenToast(false);
  };

  useEffect(() => {
    setControlAccess(userData.controlAccess);
  }, [userData]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openToast}
        autoHideDuration={3000}
        onClose={handleToastClose}
      >
        <Alert
          onClose={handleToastClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Copied!
        </Alert>
      </Snackbar>
      {initialLoading && (
        <div className="singleContainer">
          <div className="intialItem">
            <CircularProgress />
          </div>
        </div>
      )}
      {!initialLoading && !isDataAvailable && (
        <div className="singleContainer">
          <div className="intialItem">{errorMessage}</div>
        </div>
      )}
      {!initialLoading && isDataAvailable && (
        <div className="singleContainer">
          <div className="top">
            <div className="left">
             
              {controlAccess === "full" && type === "main" && (
                <div className="editButton" onClick={handleEditClick}>
                  Edit
                </div>
              )}

              <div className="item">
                <div className="itemImgSection">
                  <img src={bookData.thumbImage} alt="" className="imgItem" />

                  <div className="viewPdf">
                    <Button fullWidth variant="outlined">
                      <a
                        href={bookData.pdfUrl}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        View PDF
                      </a>
                    </Button>
                    <Button
                      fullWidth
                      sx={{ marginTop: "8px" }}
                      variant="outlined"
                    >
                      <a
                        href={bookData.samplePdfUrl}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        View Sample PDF
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="details">
                  <h4 className="itemTitle">{bookData.name}</h4>

                  {bookData.payment_type !== "Free" && (
                    <>
                      {" "}
                      <span className="badge text-bg-danger mb-1">
                        {bookData.discount + "%"}
                      </span>
                      <div className="detailItem">
                        <span className="itemPriceValue">
                          {"₹" +
                            Math.ceil(
                              bookData.price -
                                (bookData.price / 100) * bookData.discount
                            )}
                        </span>
                        <span className="itemPrice">
                          {"₹" + bookData.price}
                        </span>
                      </div>
                    </>
                  )}
                  {bookData.payment_type === "Free" && (
                    <h5>
                      <span className="badge text-bg-success  mb-3">
                        {"Free"}
                      </span>
                    </h5>
                  )}

                  <div className="detailItem">
                    <span className="itemValue">{bookData.eType + " | "}</span>
                    <span className="itemValue">
                      {bookData.pages + " pages"}
                    </span>
                  </div>

                  <div className="detailItem">
                    <span className="itemKey">About:</span>
                    <span className="itemValue">{bookData.about}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Category:</span>
                    <span className="itemValue">{bookData.category}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Language:</span>
                    <span className="itemValue">{bookData.language}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">ISBN no.:</span>
                    <span className="itemValue">{bookData.isbn}</span>
                  </div>

                  <div className="detailItem">
                    <span className="itemKey">Author:</span>
                    <span className="itemValue">{bookData.author}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Publisher:</span>
                    <span className="itemValue">{bookData.publisher}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">PDF Password:</span>
                    <span className="itemValue me-2">
                      {bookData.pdf_password}
                    </span>
                    <ContentCopyOutlined
                      color="primary"
                      fontSize="small"
                      onClick={handleCopiedTextClick}
                    />
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Unit Sold:</span>
                    <span className="itemValue">{bookData.unitSold}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Published on:</span>
                    <span className="itemValue">
                      {formatTimestamp(publishedOn)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Single;
